import cPLogoDark from "@assets/svg/cp-logo-dark.svg"
import cPLogo from "@assets/svg/cp-logo.svg"
import LogoutIcon from "@assets/svg/navigation/logout.svg?react"
import {
	AppShell,
	Group,
	Image,
	MantineStyleProps,
	Text,
	UnstyledButton
} from "@mantine/core"
import { useMantineColorScheme } from "@mantine/core"
import { useAuthContext } from "@context/AuthProvider"
import styles from "./AppHeader.module.css"
import { useAEMDictionary } from "@AEM/hooks/useAEMDictionary"

function MinimalHeader({ ...props }: MantineStyleProps) {
	const { colorScheme } = useMantineColorScheme()
	const { logout } = useAuthContext()
	const logo = colorScheme === "dark" ? cPLogoDark : cPLogo
	const { dictionary } = useAEMDictionary()

	return (
		<AppShell.Header
			withBorder={false}
			{...props}
			h={{ base: 48, sm: 70 }}
			className={styles.appShellMinimal}
			pos="fixed"
		>
			<Group
				px={{ base: "sm", md: "xl" }}
				wrap="nowrap"
				align="center"
				justify="space-between"
				h="100%"
				w="100%"
			>
				<Image
					src={logo}
					alt="CruisingPower"
					w={{ base: 199, md: 214, sm: 214 }}
					h={{ base: 28, md: 31, sm: 31 }}
					style={{ pointerEvents: "none" }}
				/>
				<UnstyledButton
					onClick={() => logout()}
					variant="icon-hover"
					className={styles.logoutBtn}
					aria-label="Log out"
				>
					<Group gap="xs" data-qa="header.button.logout">
						<LogoutIcon />
						<Text span fz={9} fw={500} lh={2.2} visibleFrom="sm">
							{dictionary?.LogoutLabel || ""}
						</Text>
					</Group>
				</UnstyledButton>
			</Group>
		</AppShell.Header>
	)
}

export default MinimalHeader
